import Layout from "@/components/Layout";
import PageMeta from "@/components/seo/PageMeta";
import { buildWebsiteSchema, buildOrganizationSchema } from "@/components/seo/schemas";
import HeroSection, { HERO_IMAGE, HERO_SRCSET } from "@/components/home/HeroSection";
import CategoriesSection from "@/components/home/CategoriesSection";
import FeaturedSpas from "@/components/home/FeaturedSpas";
import StatsSection from "@/components/home/StatsSection";
import CTASection from "@/components/home/CTASection";
import GuidesSection from "@/components/home/GuidesSection";
import TreatmentsSection from "@/components/home/TreatmentsSection";
import InternalLinks from "@/components/home/InternalLinks";

export default function Index() {
  return (
    <Layout>
      <PageMeta
        title="MedSpa Directory — Find Top-Rated Medical Spas Near You | 2026 Reviews"
        description="The largest MedSpa directory in the U.S. Compare 700+ verified medical spas, browse Botox, fillers, laser, and body contouring providers near you, and read real patient reviews. Free to search."
        path="/"
        jsonLd={[buildWebsiteSchema(), buildOrganizationSchema()]}
        preloadImage={HERO_IMAGE}
        preloadImageSrcSet={HERO_SRCSET}
        preloadImageSizes="100vw"
      />
      <div className="home-aurora">
        <HeroSection />
        <StatsSection />
        <CategoriesSection />
        <FeaturedSpas />
        <CTASection />
        <TreatmentsSection />
        <GuidesSection />
        <InternalLinks />
      </div>
    </Layout>
  );
}
